import http from './http'

// 用户登录
export function login (data) {
  return http.post('/client/user/login', data)
}

// 获取用户信息
export function getCurrentUser () {
  return http.get('/client/user/current')
}

// 修改用户信息
export function editUser (data) {
  return http.post('/client/user/edit', data)
}

// 修改用户信息
export function editUserPw (data) {
  return http.post('/client/user/password/edit', data)
}

// 上传头像
export function uploadAvatar (data) {
  return http.post('/client/upload/avatar', data)
}

export function getWXTicket () {
  return http.get('/client/weixin/qrcode/bind')
}

export function getCode (phone) {
  return http.get('/client/user/bind/send/code?phone='+phone)
}

export function bindPhone (data) {
  return http.post('/client/user/bind/phone', data)
}

// 修改用户信息
export function editUserName (data) {
  return http.post('/client/user/username/edit', data)
}

export function bindGPT () {
  return http.get('/client/gpt/bind')
}

// 获取用户信息
export function getLocoyVipInfoApi () {
  return http.get('/client/locoy/get/vip/info')
}

// 获取用户信息
export function getLocoyVipApi () {
  return http.get('/client/locoy/get/vip')
}

export function getScoreBySocial (data) {
  return http.post('/client/user/event/post/check', data)
}
